import { ref } from 'vue';

const userDashletsHandling = () => {
      const userDashlets_error = ref(null);
      const userDashlets = ref([]);

      const loadUserDashlets = async () => {
        try {
          let data = await fetch("/api/userdashlets");

          if (!data.ok) {
            throw Error("Can't load data");
          }

          userDashlets.value = await data.json();

          //console.log('getUserDashlets.js: ', userDashlets.value);
        } catch (err) {
          userDashlets_error.value = err.message;
        }
      };

  

    const userDashletsPut_error = ref(null);
    const syncUserDashlets = async (userDashlets) => {

      var dashlet_ids = [];
      var sort_order = [];

      userDashlets.forEach(element => {
        dashlet_ids.push(element.id);
        sort_order.push(element.user_sort);
      });
      
      console.log("putUserDAshlets  : ", dashlet_ids , " sort: " , sort_order);
      
      const postData = {
        dashletIds: dashlet_ids,
        dashletSort: sort_order
      };

      try {
      // $dashlet_ids.forEach(appendData);
       // console.log("axios post", postData)

        axios.post('/api/userdashlets', postData)
        //console.log('getUserDashlets.js: ');
      } catch (err) {
        userDashletsPut_error.value = err.message;
        console.log("Error ", userDashletsPut_error.value);
      }
    };

    const userDashletsPatch_errors = ref(null);
    const patchUserDashlets = async (userDashlet) => {

      var errors = userDashletsPatch_errors;
      
        const response = await axios.put('/api/user/' + userDashlet.pivot.user_id + '/dashlet/' + userDashlet.id ,userDashlet)
          .then(response => {
            errors.value = null;
            //console.log("Response: " , response);
          })
          .catch((error) => {
            //console.log("Error: ", error.response.data.errors);
            errors.value = error.response.data.errors;
        });

        // try {
        //   const response = await axios.put('/api/user/' + userDashlet.pivot.user_id + '/dashlet/' + userDashlet.id ,userDashlet);
        //   errors.value = null;
        // //     console.log("Response: " , response);
        // } catch (error) {
        //       console.log("Error: ", error.response.data.errors);
        // //     errors.value = error.response.data.errors;
        // }
        // finally {
        //   console.log("Finally-Request: Put resolved and request returned back.");
        // }

    };

    return {userDashlets, userDashlets_error, loadUserDashlets, userDashletsPut_error, syncUserDashlets, patchUserDashlets, userDashletsPatch_errors };
  }

export default userDashletsHandling;  